<template>
  <div class="device07_mensuo_wraper device_control_page_wraper">
    <div class="close_img_top">
      <img
        src="~assets/img/controlpublic/control-guanbi-chahao.png"
        @click="$closeControlToast"
        alt
      />
    </div>

    <!-- objData.passwordState =0  说明没有开启密码验证功能  =1说明开启了密码验证功能 -->
    <div v-if="userpasswordState  === 0">
      <div class="devce_name z_ellipsis1">{{objData.remark}}</div>

      <div class="content07_wraper content027_wraper">
        <div class="device_07_text">状态：{{computerState}}</div>
        <!-- 控制按钮样式部分 -->
        <div class="device07_btn_wraper">
          <div class="one_btn_07_wraper" @click="device07BtnClickHandle(0)">关锁</div>
          <div class="one_btn_07_wraper" @click="device07BtnClickHandle(1)">开锁</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="devce_name z_ellipsis1">{{objData.remark}}</div>
      <div class="devce_name z_ellipsis1">安全保护验证</div>

      <input
        class="device_mi_ma_yan_zheng input_public_ime_mode"
        type="password"
        placeholder="请输入正确的登录密码"
        v-model="userpassWord"
        autoComplete="new-password"
        onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"
      />

      <div class="btn_wraper">
        <div
          class="btn_return public_control_click public_z_index6"
          @click="$closeControlToast"
        >返回取消</div>
        <div
          class="btn_determine public_control_click public_z_index6"
          @click="determineBtnHandle"
        >确定密码</div>
      </div>
    </div>

    <!-- <BUtton @click="btnhandle">按钮</BUtton> -->
  </div>
</template>

<script>
// import { controlBtnRequestHandle } from "components/content/control-toast/control-toast-classify/device-public-js";
import {
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
import store from 'store/index' ///导入公共仓库

export default {
  data() {
    return {
      userControlData: this.objData,
      // {
      //   ///用户设置的缓冲数据
      //   openState: this.objData.openState, ///0是关锁 1是开锁
      //   openStateValue: this.objData.openStateValue, //无用
      //   openStateValue1: this.objData.openStateValue1, ///无用
      //   openStateValue2: this.objData.openStateValue2 ///无用
      // },
      userpassWord: '',
      userpasswordState: this.objData.passwordState ///无用
    }
  },
  props: {
    objData: Object ///要控制设备的数据
  },
  methods: {
    device07BtnClickHandle(mode) {
      ///按钮按下
      console.log('22222222222222')
      this.userControlData.openState = mode
      // controlBtnRequestHandle(this.userControlData, this.objData ,this.userpassWord); ///控制请求服务端的公共方法
    },
    determineBtnHandle() {
      if (this.userpassWord === '') {
        this.$toast('密码不能为空！')
        return
      }

      console.log('111111111')

      /// 设置设备是否开机密码保护接口，获取数据
      this.$request({
        method: 'post',
        url: '/device/updateDevicePwdStateById',
        data: {
          token: store.state.token,
          deviceId: this.objData.deviceId,
          password: this.userpassWord,
          passwordState: this.objData.passwordState
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message)
            ////说明信息填写错误,控制失败了，
            return
          } else {
            ////、控制成功了
            this.userpasswordState = 0
            // this.serveDeviceListData = res.data.data; ////拿到服务器返回的数据结果
            // this.$showTipsToast(1, "获取成功", true); ////提示框
          }
        })
        .catch(error => {
          console.log(error)
        })
    }

    // btnhandle() {
    //   this.userControlData.openStateValue++;
    // }
  },
  computed: {
    computerState() {
      if (this.userControlData.openState === 0) {
        return '已关锁'
      } else {
        return '已开锁'
      }
    }
  },
  watch: {
    'objData.openState': {
      // deep:true,
      handler: function(val) {
        ///保证服务器数据和用户设置的数据同步
        console.log(val)
        this.userControlData.openState = val
      }
    }
  }
}
</script>

<style>
.device07_mensuo_wraper {
  height: 500px;
}

.content07_wraper {
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
/* 控制按钮样式部分 */
.device07_btn_wraper {
  width: 100%;
  height: 80px;

  display: flex;
  justify-content: space-around;
  align-items: center;
}
.one_btn_07_wraper {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  /* border: 1px solid #f5f5f5; */
  border-radius: 4px;
  background-color: #f5f5f5;
  color: #282828;
}

.one_btn_07_wraper:active {
  background: #a0a3a5;
}
.device_07_text {
  margin-top: 40px;
}
</style>
